import { Action, createAction, props } from '@ngrx/store';
import { User } from '../../models/domain';

export const UserActionType = {
  CreateUser: '[User] Create user',

  UserCreated: '[User] User successfully created',

  LoadUsers: '[Users] load',

  UsersLoaded: '[Users] Users loaded',

  SpecificUserLoaded: '[Users] Specific User Loaded',

  UpdateUser: '[Users] User updated',

  UserUpdated: '[User] User updated',

  RemoveUser: '[User] Remove user',

  UserRemoved: '[User] User removed',

  ResendUserInvitation: '[User] Resend user invitation',
};

export class UserCreatedAction implements Action {
  readonly type = UserActionType.UserCreated;

  constructor(public payload: User) { }
}

export class CreateUserAction implements Action {
  readonly type = UserActionType.CreateUser;

  constructor(public payload: { user: User, notification: Record<string, string> }) { }
}

export class LoadUsersAction implements Action {
  readonly type = UserActionType.LoadUsers;
}

export class UsersLoadedAction implements Action {
  readonly type = UserActionType.UsersLoaded;

  constructor(public payload: User[]) { }
}

export class ResendUserInvitationAction implements Action {
  readonly type = UserActionType.ResendUserInvitation;

  constructor(public user_email: string) { }
}

export class UpdateUserAction implements Action {
  readonly type = UserActionType.UpdateUser;

  constructor(public user: User) { }
}

export class UserUpdatedAction implements Action {
  readonly type = UserActionType.UserUpdated;
  constructor(public user: User) { }
}

export class RemoveUserAction implements Action {
  readonly type = UserActionType.RemoveUser;

  constructor(public payload: { email: string }) { }
}

export class UserRemovedAction implements Action {
  readonly type = UserActionType.UserRemoved;

  constructor(public payload: { email: string }) { }
}

export const UsersAdapterActions = {
  loadUsers: createAction(UserActionType.LoadUsers),
  usersLoaded: createAction(UserActionType.UsersLoaded, props<{ payload: User[] }>()),
  userUpdated: createAction(UserActionType.UserUpdated, props<{ user: User }>()),
  removeUser: createAction(UserActionType.RemoveUser, props<{ payload: { email: string } }>()),
  userRemoved: createAction(UserActionType.UserRemoved, props<{ payload: { email: string } }>()),
  userRemovedSuccessfully: createAction('[User] User removed successfully', props<{ email: string }>()),
  userRemovalFailed: createAction('[User] User removal failed', props<{ email: string }>()),
  createUser: createAction(UserActionType.CreateUser, props<{ payload: { user: User } }>()),
  userCreated: createAction(UserActionType.UserCreated, props<{ payload: User }>()),
  changeRole: createAction('[Users] change role', props<{ email: string, newRoleKey: string }>()),
  toggleEmailLogin: createAction('[Users] toggle email login', props<{ email: string }>()),
  emailLoginChangedSuccessfully: createAction('[Users] email login changed successfully', props<{ email: string, emailLoginDisabled: boolean }>()),
  emailLoginChangeFailed: createAction('[Users] email login change failed', props<{ email: string }>()),
  changeAuditorPermissions: createAction('[Users] change auditor permissions', props<{ email: string, auditFrameworks: string[] }>()),
  auditorPermissionsChanged: createAction('[Users] auditor permissions changed', props<{ email: string, newAuditFrameworks: string[], oldAuditFrameworks: string[] }>()),
  auditorPermissionsChangeFailed: createAction('[Users] auditor permissions change failed', props<{ email: string, newAuditFrameworks: string[] }>()),
  roleChanged: createAction('[Users] role changed', props<{ email: string, newRoleKey: string, oldRoleKey: string }>()),
  roleChangeFailed: createAction('[Users] role change failed', props<{ email: string, newRoleKey: string }>()),
  userInvitationResent: createAction('[User] user invitation resent', props<{ email: string }>())
};
